export const en = {
	locale: 'en',
	yes: 'Yes',
	not: 'No',
	report_title: 'Reports',
	number: 'Number',
	month_select: 'Select Month',
	monthly: 'Monthly',
	month: 'month',
	year: 'year',
	biennial_unit: '2 years',
	outted: 'Output',
	inner: 'Input',
	add_new_number: 'Add new number',
	edit_number_meta: 'Change number',
	amount_of_actived_numbers:
		'Numbers {avaliableToActive, plural, one {available} other {available}} {actived}/{avaliableToActive}',
	amount_of_numbers_new_plan:
		'Used numbers: PRO {active_pro}/{total_pro} BASIC: {active_basic}/{total_basic}',
	actives: 'Active',
	inactives: 'Inactive',
	inactive: 'Inactive',
	numbers_title: 'List of numbers',
	just_left: 'Just missing',
	subscription_title: 'Subscription',
	renew: 'Renew',
	renew_now: 'Renew now',
	day: '<b>{day, plural, one {# day} other {# days}}</b>',
	connected_channels_title: 'Connected Channels',
	terms_of_use_title: 'Terms of Use',
	terms_of_use_conditions: 'Personal Data Processing Conditions',
	terms_of_use_secure: 'Privacy Policy',
	update_list_title: 'Updates',
	last_update_title: 'Latest Updates',
	last_update_system_version: 'Current System Version',
	see_more: 'See more',
	last_update_your_version: 'Your current version',
	edit: 'Edit',
	unlink_channel: 'Unlink Channel',
	link_channel: 'Link Channel',
	delete: 'Delete',
	clear_queue: 'Clear queue',
	add_numbers_title: 'Add new number',
	edit_numbers_title: 'Editing number: {number}',
	numbers_form_nickname: 'Nickname',
	total_campaign: 'Queued messages',
	update_campaign: 'Update',
	cancel_campaign: 'Clear queue',
	form_msg_nickname: "OPS, You didn't choose the nickname",
	numbers_form_api: 'Choose API',
	form_msg_api: "Oops, you didn't choose api",
	numbers_form_token: 'Integrator TOKEN',
	form_msg_token: 'OPS, You did not enter the API token',
	numbers_form_account: 'Instance ID / Account ID',
	form_msg_account: 'OPS, Enter Instance ID or Account ID',
	numbers_form_namespace: 'Channel Namespace',
	form_msg_namespace: "Ops, enter the channel's namespace",
	numbers_form_country: 'Country of origin',
	numbers_form_openai_token: 'Enter your OpenAI API token',
	msg_error_openai_token:
		'Number saved successfully, but there was an issue saving the OpenAI settings. Please try again.',
	form_country: 'Country of origin',
	steps_form_country: 'Country of origin',
	form_msg_country: 'OPS, you must enter your home country',
	form_is_national: 'Contact Source',
	form_msg_is_national: 'OPS, You must enter if you have only national contacts.',
	numbers_form_phone_number: 'Mobile Number',
	form_msg_phone_number: 'OPS, Enter Mobile Number',
	form_msg_channel_id: 'OPS, Enter Channel ID',
	steps_form_channel: 'Channels',
	steps_form_phone_number: 'OPS, Enter Mobile Number',
	steps_form_namespace: 'Channel namespace',
	form_status: 'Device Status',
	form_msg_status: 'OPS, Did you forget to check whether your device is online or offline',
	additional_settings: 'Additional settings',
	audio_transcription: 'Audio Transcription',
	audio_transcription_column: 'Transcription',
	form_msg_audio_transcription: 'Please select audio transcription option',
	enabled: 'Enabled',
	disabled: 'Disabled',
	openai_token: 'OpenAI Token',
	form_msg_openai_token: 'Please enter a valid OpenAI token',
	link_channel_title: 'Link channel',
	link_form_channel: 'Choose Channel',
	link_channel_success: 'Channel successfully linked!',
	link_channel_error: 'Error linking channel',
	unlink_channel_success: 'Channel successfully unlinked!',
	unlink_channel_error: 'Error unlink channel',
	unlink_channel_msg: 'Are you sure you want to unlink this channel',
	clear_queue_msg:
		'Are you sure you want to clear the queue? This will cancel all messages that were sent from Bitrix24 while the number was disconnected.',
	number_of_messages_on_queue: 'Number of messages on queue: ',
	delete_msg: 'Are you sure you want to delete',
	placeholder_search_address: 'Search address',
	loading_map: 'Loading map...',
	map_load_error: 'Unable to load the map.',

	// Campaign translations
	delete_campaign_warning:
		'There is a campaign running for this number, removing it will also delete it.',
	clear_campaign_queue: 'Are you sure you want to clear the campaign queue ',
	clear_campaign_queue_success: 'Campaign queue successfully deleted!',
	clear_campaign_queue_error:
		'OPS! It was not possible to delete the campaign queue for this number.',
	create_campaigns: 'Learn how to create marketing campaigns on Bitrix24 using PowerZap! {link}',
	send_only_during_work_hours: 'Send only during work hours',
	confirm_notification_noLinkedChannel:
		'The configured number is not linked to any open channel. In this case, there are no service hours to consider and messages will be sent at any time.',
	confirm_notification_worktimeDisabled:
		'The open channel to which the number is connected does not have defined service hours. In this case, the option will be disregarded and messages will be sent at any time.',

	work_hours_defined_in_bitrix24_channel:
		'Working hours defined in the open Bitrix24 channel, of the number in question.',
	click_here_to_configure: 'Click here to configure.',
	clear_queue_immediately: 'Clear queue immediately',
	settings: 'Settings',

	last_update_version: 'Update Report - Version {version}',
	api: 'API',
	actions: 'Actions',
	clear_queue_success: 'Queue cleared!',
	clear_queue_error: 'Error clearing the queue',
	delete_number_success: 'Number successfully deleted!',
	delete_number_error: 'OPS! We could not delete your number',
	not_found_registers: 'No records found!',
	alert_audio:
		'ATTENTION: It is only possible to send audio or attachment to conversations that have already been started. Sending audio or attachment to a new conversation may cause the number to be blocked!',
	toggle_mbird: 'Do you want to send audio or an attach to number with active conversation?',
	new: 'New',
	online: 'On',
	offline: 'Off',
	channel_name: 'Open Channel Name',
	edit_number_success: 'Number successfully edited!',
	add_number_success: 'Number successfully added!',
	tutorials_title: 'Tutorials',
	all_numbers: 'All numbers',
	step_one: 'Welcome',
	step_two: 'Integrator',
	step_three: 'Setting up',
	step_four: 'Device',
	step_five: 'Done',
	step_six: 'Webhook',
	step_seven: 'Open Channel',
	choice_title: 'How would you like to connect?',
	choice_subtitle: 'Choose the option that makes the most sense for you right now.',
	choice_qr_title: 'Direct connection',
	choice_qr_b1: 'No cost per conversation',
	choice_qr_b2: 'Quick connection, straight from WhatsApp',
	choice_qr_b3: 'Good for day-to-day support',
	choice_qr_b4: 'Continuous use up to moderate scale',
	choice_qr_highlight: 'Best if you want to start replying right away',
	choice_meta_title: 'Official API (Meta)',
	choice_meta_b1: 'Charged per conversation started. <link>Learn more</link>',
	choice_meta_b2: 'Requires approval from Meta',
	choice_meta_b3: 'No technical sending limit',
	choice_meta_b4: 'Designed for larger operations',
	choice_meta_highlight: 'Teams that already run professional support',
	qr_title: 'Connect your WhatsApp number',
	qr_subtitle: 'Scan the QR Code to start replying on WhatsApp straight from Bitrix24.',
	qr_before: 'Before scanning:',
	qr_step_1: 'Open WhatsApp on your phone.',
	qr_step_2: 'Tap the three dots (or the settings icon) and open "Linked devices".',
	qr_step_3: 'Scan the QR Code next to this text.',
	qr_after: 'After scanning, <b>wait for your session to load.</b>',
	qr_expired: 'The code expired',
	qr_regenerate: 'Generate QR Code again',
	qr_loading: 'Preparing your QR Code',
	qr_loading_hint: 'This may take a few seconds.',
	connected_title: 'Number connected successfully!',
	connected_subtitle: 'Now let us link this number to an Open Channel so it can receive messages.',
	final_title: 'All set! Your PowerZap is configured',
	final_subtitle:
		'You can already see the conversation in Chat, or set up the Open Channels in Bitrix24 to organize your team.',
	final_cta_bitrix: 'Set up channels in Bitrix24',
	final_cta_chat: 'Go to Chat',
	pz_notice:
		'The number stays linked to the channel selected here in Powerzap. In Bitrix24, check that agents and permissions are set up.',
	pz_notice_link: 'Learn how to set up your PowerZap in Bitrix24 <link>by clicking here</link>.',
	channel_title: 'Choose the Bitrix24 Open Channel to link this number to',
	channel_subtitle:
		'Messages from this number will be distributed among the agents of the selected channel.',
	channel_count: '{count, plural, one {{padded} Open Channel} other {{padded} Open Channels}}',
	choice_footer: 'Still unsure how to connect? <link>Click here</link> for more information.',
	to_start: 'Now that you have downloaded our connector, select one of the available integrators',
	what_is_integrator: 'NOTE: Integrator is the platform that will do the messaging service',
	with_base: 'Based on the side image',
	type_token: 'Type Token',
	type_device_id: 'Enter Device ID / Account ID',
	type_namespace: "Enter the Channel's Namespace",
	steps_form_account: 'Device ID or Account',
	select_country: 'What is your country of origin?',
	type_number: 'Tell us the mobile number you will use to send messages.',
	agree0: 'Send messages',
	agree_desc0: 'Notify your leads or customers directly from Bitrix24.CRM entities',
	agree1: 'Receive messages',
	agree_desc1: 'Connect Whatsapp to open channels and have all native features',
	agree2: 'Distribute contacts',
	agree_desc2: 'With just one Whatsapp number you can distribute the conversations to your team',
	agree3: 'Automate',
	agree_desc3: 'You can set up unlimited rules for sending automatic messages on Bitrix24',
	all_done: 'All set, the App is ready for use!',
	done: 'Go to the APP',
	previous: 'Previous',
	next: 'Next',
	continue_configuration: 'Continue setup',
	meta_connect_subtitle: 'You will be redirected to the Meta connection page.',
	meta_connect_intro: 'Keep your account protected while connecting to the official Meta API:',
	meta_connect_step_1:
		'Do not connect the same number to any other platform through an unofficial API.',
	meta_connect_step_2: 'Verify your business on Meta. <link>Go there</link>',
	meta_connect_step_3: 'Add a valid payment method on Meta. <link>Go there</link>',
	meta_connect_step_4: 'Have at least one approved message template. <link>Go there</link>',
	meta_connect_error_title: 'Connection failed',
	meta_connect_error_description:
		'Check that your Meta account information is correct and try again.',
	meta_connecting: 'Connecting your number…',
	meta_connect_retry: 'Try again',
	choice_pro_only: 'Available for PRO subscribers',
	choice_upgrade: 'Upgrade',
	channel_load_error: 'We could not load the Open Channels data.',
	channel_empty:
		'No Open Channel found in your Bitrix24. Create an Open Channel and refresh the list to continue.',
	channel_create: 'Create Open Channel in Bitrix24',
	channel_reload: 'Refresh list',
	meta_connect_error_interrupted: 'The connection with Meta failed or was interrupted. Try again.',
	skip: 'Skip',
	confirm_skip: 'Do you really want skip the configuration tutorial?',
	billing_point1: 'Open Channel Integration',
	billing_point2: 'CRM messaging',
	billing_point3: 'Unique Automation Rule',
	billing_point4: 'Choose from multiple APIs',
	billing_point5: 'Unlimited Support',
	billing_point6: 'Up to 20,000 messages exchanged per month',
	free_test: 'Free Trial',
	from_price: 'from value of ',
	discount: 'discount',
	annualy: 'Annualy',
	add_subscription_error: 'There was an error activating trial.',
	add_number_error: 'Unable to save, verify the given data.',
	actual_month: 'Current Month',
	last_month: 'Last month',
	subscription_expired_msg: 'Your subscription has expired, please check the subscription area !.',
	national: 'National',
	not_national: 'National/International',
	not_done_yet: 'We are almost there! Only one step to go.',
	not_done_yet2: "You need to configure webhook now, let's go!",
	not_done_yet3: 'Follow this tutorial:',
	not_done_yet4: 'Esse número que está vinculando será para o canal: ',
	subscription_expired: 'Subscription has expired, try renewing it now !.',
	try_send: 'To test your app, try sending a message below',
	first_message_title: 'Send your first message',
	first_message_subtitle: 'Test your app by sending a message right now!',
	first_message_preview: 'Test your app by sending a message right now!',
	first_message_default: 'Hi! This is a test message straight from PowerZap.',
	first_message_send: 'Send message',
	first_message_to_placeholder: 'Add a number to test',
	first_message_to_add: 'Add number',
	first_message_notify:
		'Your PowerZap test message was sent! When the test number replies, the conversation shows up in Chat.',
	first_message_select_template: 'Select the message template',
	first_message_templates_error:
		'We could not load the message templates. Make sure there is at least one message template registered in your Meta account.',
	first_message_channel_error:
		'We could not send your message. Make sure your Open Channel is configured and try again.',
	first_message_send_error: 'We could not send your message.',
	select_destination: 'Select the destination number',
	type_your_msg: 'Enter your message',
	send_msg: 'Send',
	files_text1_mobile: 'Click to upload file',
	files_text1: 'Click or drag file to this area to upload',
	files_text2: 'Support for a single or bulk upload.',
	file_type: 'Only is supported jpg, png, pdf files',
	send_message_success: 'Message sent',
	send_message_error: 'Error on send message',
	send_message_unexpected_error:
		'An unexpected error has occurred while sending the message, please contact our support team.',
	url_signature_expired: 'Media URL has expired. Please update the URL in template settings.',
	empty_parameters: 'Fill in all template parameters.',
	location_required: 'Fill in the template location field.',
	back: 'Back',
	current: 'Current',
	select: 'Select',
	hello: 'Hello {name} :)',
	have_update: 'Your app have an update.',
	have_update_button: 'Update now!',
	updated_successfull: 'Updated sucessfully',
	updated_error: 'Update error',
	welcome: 'Congratulations!',
	welcome_title: 'Great to have you here!',
	welcome_subtitle: 'Let\u2019s connect your WhatsApp?',
	welcome2: 'You just installed the best Whatsapp connector from Bitrix24',
	welcome3: 'and you are just a few steps away from escalating your service with Whatsapp.',
	example_number:
		'Example: 554499999999, 55 means country code, 44 is city code, another number are the real number',
	oficial: 'Oficial API',
	oficial_twilio:
		"IMPORTANT: \n Twilio is an integrator of Whatsapp's Official API,  n with this you need to request approval from the number on Facebook (owner of Whatsapp).  n This approval period takes an average of 30 days .  n If you do not want to wait for this period, hire another integrator and use the application immediately.  n Just go back to the previous step and select the Integrator that best fits your need. ",
	zapbox_desc:
		"To set up your number, it is necessary that you have already contracted a plan and activated your account at Zapbox. If you have not already done so, access the Zapbox panel and activate your number <a target='_blank' href='https://whatsweb.app/account/login'>(Click here to access)</a> ",
	twilio_desc:
		"IMPORTANT: \n Twilio is an integrator of Whatsapp's Official API,  n with this you need to request approval from the number on Facebook (owner of Whatsapp).  n This approval period takes an average of 30 days .  n If you do not want to wait for this period, hire another integrator and use the application immediately.  n Just go back to the previous step and select the Integrator that best fits your need. ",
	not_oficial: 'Not Oficial API',
	not_oficial_desc:
		'Unofficial integrators. Our connector has no link to the integrators. For more information, access the Privacy Policies and Terms of Use.',
	open_channel:
		"Bitrix24's Open Channels collect messages from all communication channels with customers and distribute them among the agents in the queue. <br> <br> To learn more about the Open Channels <a target='_blank' href='https://helpdesk.bitrix24.com.br/open/9612023/'> (Click here to access)</a>",
	time_left: 'You have  {days, plural, one {# day} other {# days}} left to expire your trial',
	subscription_error_warning:
		'There seems to be an error with your subscription, check it with your admin',
	cancel: 'Cancel',
	subscription_limit_msg: 'You exceed your limit of numbers enabled by your plan.',
	msg_empty: 'Message can not be empty',
	to_empty: 'Destination number can not be empty',
	params_empty: 'All text fields are required',
	from_empty: 'From number can not be empty',
	sending_message: 'Sending message...',
	promotion_title: ' Scaling company results with Whatsapp + Chat Booster',
	promotion_text1: ' ROI lift',
	promotion_text2: ' Service priority',
	promotion_text3: ' 24h Opportunity Generation',
	promotion_text4: ' Automating responses for each customer profile',
	promotion_text5: ' Lead Qualification',
	promotion_text6: ' End-to-end benefits, from Marketing to After Sales',
	try_now: 'Try now',
	dont_show_again: "Don't show again",
	close: 'Close',
	number_empty: 'Number is empty!',
	token_empty: 'Token is empty!',
	device_id_empty: 'Device id is empty!',
	namespace_empty: 'Namespace is empty!',
	api_empty: 'Choose an api!',
	under_maintenance: 'Report Module momentarily disabled for update',
	know_you_better: 'We Want to know you better!',
	prioritize_your_resources: 'This way we can prioritize your essencial resources!',
	full_name: 'Full name',
	enterprise_website: 'Enterprise website',
	email: 'E-mail',
	email_error: 'Please enter a valid email address',
	enterprise_phone: 'Phone/WhatsApp',
	enterprise_phone_error: 'Please enter a valid phone number',
	country: 'Country',
	send: 'Send',
	lead_status: 'Status',
	deal_category: 'Pipeline',
	deal_stage: 'Stage',
	from_number: 'From number',
	to_numbers: 'To numbers',
	to_number: 'To number',
	log_messages: 'Log Messages',
	date: 'Date',
	message_count: 'Total messages exchanged in the month',
	message_in: 'Received',
	message_out: 'Sent',
	message_total: 'Total messages this month',
	warning_message_count: 'You can now track the amount of messages exchanged during the month.',
	warning_amount_numbers:
		"From now on you don't have to worry about the amount of numbers available!",
	custom_made_plan_title: 'Customize your plan',
	custom_made_plan_body:
		'Exchange + 20,000 messages/month with a custom plan made for your company',
	custom_made_plan_button: 'Request price',
	record_audio_tooltip: 'Record audio',
	play_audio_tooltip: 'Play audio',
	discard_audio_tooltip: 'Discard audio',
	attach_audio_tooltip: 'Attach audio',
	recording_audio: 'Recording...',
	reports_leads_title: 'WHATSAPP LEADS',
	reports_leads_title_warning: 'Remember, this report is for the reported period!',
	reports_deals_title: 'WHATSAPP DEALS',
	reports_deals_title_warning: 'Remember, this report is for the reported period!',
	data_picker: 'Reporting period',
	percent_leads: 'Leads Percentage',
	percent_warning: 'Generated by Whatsapp in relation to the total, in the selected period.',
	percent_deals: 'Deals Percentage',
	chart_ticket: 'Monthly Deals earnings generated by Whatsapp',
	reports_ticket_title_warning: 'Remember, this report is for the reported period!',
	deals_op_warning: 'Remember, this report is for the reported period!',
	deals_op: 'Total value of Deals generated by Whatsapp',
	marketing_campaigns_tab_title: 'MARKETING CAMPAIGNS',
	billing_central_tab_title: 'BILLING',
	help_tab_title: 'HELP',
	permissions_tab_title: 'PERMISSIONS',
	dashboard_tab_title: 'DASHBOARD',
	reports_tab1: 'REPORTS',
	data_picker_gerar: 'Generate reports',
	message_count_warning_title: 'Warning!',
	message_count_warning_message: 'Report data temporarily unavailable!',
	image_banner: 'banner_esignature_en.jfif',
	try_now_month: 'I Want the Monthly Plan!',
	try_now_year: 'I Want the Annual Plan!',
	choose_an_integrator: 'Choose an integrator to proceed',
	warning_maximum_file_size: 'The file is larger than 100MB.',
	view_header_document: '📄 View document',
	warning_header_image: 'Please upload an image to proceed.',
	leads: 'Leads',
	won: 'Won',
	in_progress: 'In progress',
	lost: 'Lost',
	converted: 'Converted',
	monthly_profit: 'Monthly Profit',
	month_0: 'January',
	month_1: 'February',
	month_2: 'March',
	month_3: 'April',
	month_4: 'May',
	month_5: 'June',
	month_6: 'July',
	month_7: 'August',
	month_8: 'September',
	month_9: 'October',
	month_10: 'November',
	month_11: 'December',
	open_channels: 'Open Channels',
	open_channels_text: 'The data presented refer to the following open channels:',
	open_channels_tooltop:
		'To show data from another WhatsApp open channel, link the open channel to some number in the DASHBOARD tab',
	open_channels_empty: 'Link an open channel to WhatsApp to receive report data!',

	// SubscriptionView
	my_subscription: 'Manage my subscription',
	subscription_now: 'Activate subscription now',
	update_payment: 'Update credit card',
	renew_failed: '<b>Your subscription could not be renewed.</b>',
	trial_expired:
		'<strong>Your trial period is over.</strong> {br} Activate your subscription to continue using the app.',
	trial_left: 'Your free trial period will end in',
	trial_final_1: 'Your trial period is ending! Only ',
	trial_final_2: ' left. Choose your subscription plan or <a>click here</a> for help.',
	on_hold_message: 'Update your credit card info to continue using the app.',
	active_left: 'Your subscription will automatically renew in',
	alert_title: 'Authentication Error',
	alert_message:
		'For the authentication process to take place correctly, a user with administrator permissions must access the application.',
	template: 'Select a template',
	template_title: 'Template (disabled in case of audio or file)',
	template_error: 'Error fetching template',
	template_fetch_permission_error:
		'Your WhatsApp Business Account access permissions may have been removed or expired. Please verify that your account still has access with the partner and that the access token is valid.',
	unknown_error: 'Unknown error',
	possible_cause: 'Possible cause',
	template_error_envio:
		'There was a failure sending the template to one or more numbers in the list. Check the template used and the destination numbers entered.',
	template_edited:
		'The template could not be sent. It was recently edited and is still awaiting Meta approval. We recommend creating a new template to expedite the verification process.',
	healthy_ecosystem: 'This message was not delivered to maintain healthy ecosystem engagement.',
	invalid_tokens:
		'Your channel token appears to be invalid. This usually happens when the number has been registered on another platform. Try adding the number again or contact support.',
	using_test_tokens: 'Use "live" tokens instead of "test" tokens.',
	legacy: 'Legacy Plan',
	basic: 'Basic Plan',
	pro: 'Pro Plan',
	total_recurring: 'Total amount',
	renew_in: 'Next payment due',
	pro_numbers: 'PRO numbers',
	basic_numbers: 'BASIC numbers',
	subscription_not_found:
		'<b>Subscription not found.</b> {br} Activate your subscription to continue using the application.',
	upgrade_subscription: 'Upgrade subscription now',
	upgrade_subscription_text: 'Upgrade your subscription to use PowerZap.',

	// Help Good Habits
	help_good_habits: 'Good Usage Practices',
	good_habits: 'Good practices for using PowerZap',
	good_habits_description:
		'Some good practices in everyday life can be essential to avoid blocking/ banning a number. Simple actions that can make a big difference. { link }',
	know_more: 'Know more.',
	alert_good_habits:
		'Learn good practices for using PowerZap to avoid blocking/banning your number. {link}',
	help_good_habits_title: '<b> Good Usage Practices </b>',
	help_good_habits_intro:
		'Some good practices in everyday life can be essential to avoid blocking/banning a number. Simple actions that can make a big difference.',
	help_good_habits_1:
		'1. Have your WhatsApp Business profile filled out (with profile photo, address, description, website, contact email, etc.).',
	help_good_habits_2: '2. Avoid sending messages to numbers that are not in your contacts.',
	help_good_habits_3:
		'3. Personalize messages with recipient information.If this is not possible, use random attributes to differentiate each message.',
	help_good_habits_4:
		"4. Encourage the recipient to interact with your number, especially if you know they don't have your number in their phonebook.",
	help_good_habits_5: '5. Offer the recipient the option to no longer receive messages.',
	help_good_habits_6: '6. Send messages ONLY to customers who have authorized receipt.',
	help_good_habits_7: '7. Avoid message content with inappropriate language.',
	help_good_habits_8: '8. Avoid sending automatic messages with links and images.',
	help_good_habits_9:
		'9. Use Bitrix24 automations cautiously for controlled and moderated uploads.',
	help_good_habits_10:
		'10. To receive messages with promotions, recommend that the recipient add the company number to their contacts and send a message saying "I want promotions". This action significantly reduces the risk of blocks, since, with the number in the phonebook and starting the conversation, the block and spam report buttons do not appear.',
	help_good_habits_11:
		'11. Personalize messages with recipient data (e.g. First Name, Last Name, Last Name, etc.) to prevent all messages from being exactly the same.',
	help_good_habits_12:
		'12. Always provide an option for the recipient to stop receiving messages. For example: "Enter 2 to no longer receive these messages." This allows you to remove numbers you no longer wish to receive from your sending lists.',
	help_ban_title: '<b> Actions in case of Blocking/Ban </b>',
	help_ban_intro_1:
		'In case of blocking/banning, it is important to follow the recovery actions and to avoid new blocking/banning.',
	help_ban_intro_2:
		'To recover a blocked/banned number, contact WhatsApp (Meta) to request unblocking through the following contact channels:',
	help_link: 'Contact link',
	help_email: '- E-mails: {email1}, {email2}',
	help_ban_intro_3: '<b> Request via Link: </b>',
	help_ban_item_1: '1. {link} to send the request to the WhatsApp team.',
	help_ban_link: 'Enter this link',
	help_ban_item_2:
		'2. Enter the banned phone number, add an email address for the reply and select the "Web and Computer" option.',
	help_ban_item_3: '3. In the request message you can use the template below:',
	help_ban_item_3_1:
		"“Our company's number has been banned from WhatsApp and we don't understand why.We evaluated the messages sent and were unable to understand what led to the ban.How can we retrieve our number and normalize our customer service? Thanks!",
	help_ban_item_3_2: 'Att YOUR_COMPANY_NAME, Brazil.”',
	help_ban_item_3_3: '<b> *OBS.: Replace YOUR_COMPANY_NAME with the name of your company. </b>',
	help_ban_item_4:
		'4. When you click next, on the next page you will click on the "Send Question" button',
	help_ban_item_4_1:
		"Ready, after sending the request, WhatsApp acknowledges receipt via email immediately, unlocking it immediately or within 3 business days. WhatsApp's response will arrive at the registered email.",
	help_ban_item_4_2: '<b> Request via Email: </b>',
	help_ban_item_4_3:
		'1. Send an email to {email1}. If there is no response after 72 hours, please send to {email2}.',
	help_ban_item_4_4:
		'2. In the title of the email, use something like "Question about WhatsApp" or "Question about bans". In the body of the email, use the following template:',
	help_ban_item_4_5:
		"“Our company number (+55 xx xxxxxxxxx) was banned from WhatsApp and we don't understand why.We evaluated the messages sent and were unable to understand what led to the ban.How can we recover our number and normalize our service? Thanks! Att YOUR_COMPANY_NAME, Brazil.”.",
	help_ban_conn: 'To connect a new number to PowerZap, pay attention to the following points:',
	help_ban_conn_1: '1. Avoid linking the new number to the same CPF/CNPJ.',
	help_ban_conn_2:
		'2. Use the previous number on the device and WhatsApp Web to send and receive messages and "warm up" the number.',
	help_ban_conn_3: '3. Avoid using the same device.',
	help_ban_conn_4: '4. Clear the number queue before connecting the device.',
	help_ban_conn_5: '5. Avoid bulk mailings initially.',
	help_ban_conn_6: '6. Do not send messages to anyone who has not authorized them to be sent.',
	help_ban_conn_7: '7. Avoid using passive-aggressive language.',
	help_ban_info: 'For more information, click here.',

	// Help Widget
	help_widget: 'Widgets',
	help_widget_title: '<b>Widget Creation</b>',
	help_widget_intro:
		'Instantly capture the contact details of your website visitors! With the PowerZap WhatsApp Button, you open the doors to engaging visitors interested directly in your offers. And the best part? Installation is simplified, taking just 2 minutes!',
	help_widget_1: 'Go to the {link} and click the "Create yours now" button.',
	help_widget_link_text: 'generator website',
	help_widget_2:
		'Fill out the form to customize your widget and indicate the WhatsApp number you want to associate with it. Then click on the "Create WhatsApp Button".',
	help_widget_3:
		'Ready, your WhatsApp button has been created! Now just click on the "Copy the code" button and paste the generated code into your Bitrix24 website, Wordpress or any other platform of your choice.',
	help_widget_4: '<b>Tutorial on integrating the widget into a WordPress page:</b>',
	help_widget_5: '<b>Tutorial on integrating the widget into a Bitrix24 website: </b>',
	help_widget_6: '<b>Tutorial on integrating the widget into a ReactJS page: </b>',
	help_alert_video: 'Unfortunately, your browser does not support video playback.',
	help_widget_btn: 'CREATE WIDGET',

	// Help MessageBird
	help_MessageBird_title: 'MessageBird (Official API)',
	help_MessageBird_1:
		'To configure our connector next to MessageBird it is interesting to start with the MessageBird screen.',
	help_MessageBird_2: 'Log in to your account and select the tab <b>Developers</b>',
	help_MessageBird_3: 'next, <b>API Acess</b> and select the <b>Add acess Key</b>',
	help_MessageBird_4: 'Name your connection and select <b>Live</b>',
	help_MessageBird_5: 'Select <b>Show key</b>',
	help_MessageBird_6: 'Copy <b>Key</b>',
	help_MessageBird_7: 'In our APP, add a device',
	help_MessageBird_8: 'Name and choose the <b>MessageBird</b>',
	help_MessageBird_9: 'Add the token in the field provided',
	help_MessageBird_10: 'Go back to MessageBird selecione and select the tab <b>Chanels</b>',
	help_MessageBird_11:
		"Choose the WhatsApp channel and if you don't have the channel, just create a new WhatsApp channel",
	help_MessageBird_12:
		'Do the <b>scan off the QR code</b> with an WhatsApp APP or send the shown message for the indicated number',
	help_MessageBird_13: 'Copy the Channel ID',
	help_MessageBird_14: 'Paste in API Whatsapp.',
	help_MessageBird_15:
		"In Messagebird's <b>Channels</b> tab go to Whatsapp, <b>My Channels</b> and copy the <b>Template Namespace</b> from the chosen channel",
	help_MessageBird_16: 'Paste the info in the highlighted field',
	help_MessageBird_17: 'Go back to MessageBird select edit',
	help_MessageBird_18:
		'Copy your device number and paste in Mobile Number inside the API Whatsapp (the integrator number has to be equal to the integrator).',
	help_MessageBird_19: 'Save and done!',
	help_MessageBird_20: 'Your app is set up.',
	help_MessageBird_21: 'Now just link it to an open channel.',

	// Help automation
	help_automation_title: 'Automations',
	help_automation_1:
		'To use automations in PowerZap, enter the automations menu in the funnel you want to add the automation rule and select the <b>icon</b> shown below:',
	help_automation_2: 'Select the "Create" option in the Automation Rules and Triggers tab.',
	help_automation_3:
		'Select the "Other" option and click "Add" in the item <b>[PowerZap WhatsApp API] WhatsApp Activity</b>.',
	help_automation_4:
		'Enter your device number <b>NOTE: The number entered must be the same registered in PowerZap</b>',
	help_automation_5: 'Select the field of the target cell phone belonging to the lead / deal.',
	help_automation_6: 'Write a message.',
	help_automation_7:
		'Select, optionally, a file to be sent along with the automation message. For this, it is necessary to create a file type field in the lead/deal card and add a file (image, video, document) to this field.',
	help_automation_8:
		'Optionally, fill in this field with a link to a file that is on your Bitrix24.Drive, to be sent along with the automation message.',
	help_automation_9:
		'For this, it is necessary to upload a file (image, video, document) to your Bitrix24.Drive, select this file and click on the "Share" option and then on the "Copy internal link" option.',
	help_automation_10: 'Then just paste the copied link in the displayed field.',
	help_automation_11: 'Select the Bitrix24 user that will be used to perform the automations.',
	help_automation_12: 'Save and done!',
	help_automation_13: '<b>SENDING TEMPLATES WITH THE OFFICIAL API</b>',
	help_automation_14: 'To send templates using the Official API, use the following syntax:',
	help_automation_15: '#template:YOUR_TEMPLATE_NAME',
	help_automation_16: '#params:PARAM1,PARAM2,PARAM3',
	help_automation_17: 'As per the example that follows:',
	help_automation_18:
		'The resulting message will be the chosen template with the parameters you defined in the automation:',
	help_automation_19:
		'Another option is to add the "File ID" to this field, for this you need to create the automation in "Flow Creator" mode and add the "Drive Object Information" and "PowerZap WhatsApp API" components.',
	help_automation_20:
		'Then, just click on the three dots next to the "Bitrix24.Drive file ID/Link" field and select the "Additional Results" option. This screen will display the item "Drive object information", you need to click on the item and choose the "ID" attribute.',
	help_automation_21:
		'This way, the field will be filled with the ID of the file selected in the "Drive object information" component.',
	help_automation_22: '<b>How to send templates with location via automation</b>',
	help_automation_23:
		'To send a template with location through automation, follow the steps below:',
	help_automation_24:
		'1. Open Google Maps, search for the desired address, and copy the full link that appears in the browser address bar.',
	help_automation_25:
		'2. In the automation, paste this link right after the #location: syntax in the message field.',
	help_automation_26:
		'3. The template will be sent automatically with the correct location to the user.',

	// Help campaign
	help_campaign_title: 'Marketing Campaign',
	help_campaign_1:
		'You can use Bitrix24 Marketing Campaign Service to send WhatsApp messages to your client base through the PowerZap application.',
	help_campaign_2:
		'To make this kind of sending you need to access the "Marketing" section of your Bitrix24, go to the "Campaign" tab and choose "CREATE CAMPAIGN", selecting the "SMS Campaign" option.',
	help_campaign_3:
		'Select a filter for the segment that you wish to send the campaign and create a recipients segment.',
	help_campaign_4:
		'The numbers registered in the PowerZap application will appear as options in the field "Send:". Choose the number from which you wish to send the campaign, edit your text message and save it. You can then send the campaign as soon as Bitrix finishes preparing your segment.',
	help_campaign_5:
		'In the video bellow you can see the steps to create a SMS Marketing Campaign in Bitrix24:',
	help_campaign_6:
		'<b>You must be aware of some important details regarding this kind of action!</b>',
	help_campaign_7:
		"1 - The sending occurs to one recipient about every minute. This is necessary so your account isn't blocked by Whatsapp. Plan your campaign ahead of time with this in mind.",
	help_campaign_8:
		"2 - Despite the time between the message sendings, the account may still be blocked if part of the recipients report the sending as SPAM. Send campaigns to a client base that want to receive your comunications and won't report you.",
	help_campaign_9:
		'3 - New campaigns created using the same Whatsapp number will only be sent after the previous campaign is finished. You can use different numbers to send campaigns at the same time period.',
	help_campaign_10:
		'If you want to cancel sending the campaign, simply access the application and go to the "Marketing Campaigns" tab. This screen will list all registered phone numbers, how many messages are still in the queue to be sent and the "Clear Queue" option.',
	help_campaign_11:
		'When clicking on the "Clear Queue" option you must confirm the action by clicking "Yes". <b> It is worth remembering:</b> that by choosing this option you will be deleting all campaign messages in the queue that are associated with the selected phone number.',
	help_campaign_12:
		'Then, the application will display a success message and the numbers that still have campaign messages in the queue to be sent.',
	help_button_title: 'Quick Reply Buttons',
	help_button_0: 'Quick Replies: Ease and Agility in Customer Service',
	help_button_1:
		'Currently, buttons are only compatible with the Pro number and 360Dialog, using the API Basic number.',
	help_button_2:
		'With quick reply buttons, interacting with our messages becomes much simpler. You can send questions with pre-set answer options, and the recipient just needs to tap the corresponding button for their response to be sent automatically, without having to type.',
	help_button_3:
		'You can use pre-defined buttons or create your own quick reply buttons. Below is the step-by-step guide to creating and using your quick reply buttons:',
	help_button_4: 'See how to use quick reply buttons directly in the chat:',
	help_button_5: 'Check below the step-by-step guide for using quick reply buttons in automations:',
	help_button_6:
		'Reinforcing that, in the videos, all button submissions in chat or automation follow the pattern #btn:Button Name. Therefore, everything placed after #btn: will be considered the name of the quick reply button.',
	help_button_7:
		'In the 360 API, card sending is still done via template, while button usage is only available in chat.',

	help_audio_transcription_title: 'Audio Transcription',
	help_audio_transcription_0: 'How to Enable Audio Transcription for Incoming Messages',
	help_audio_transcription_1:
		'The transcription feature automatically converts incoming voice messages into text. It is available for Pro numbers and numbers integrated via 360Dialog using the Basic API.',
	help_audio_transcription_2: '✅ Prerequisites:',
	help_audio_transcription_3: 'Have a Pro number or an active number via 360Dialog.',
	help_audio_transcription_4: 'Have a valid OpenAI API key to perform the transcriptions.',
	help_audio_transcription_5: 'Step-by-step to enable transcription:',
	help_audio_transcription_6: 'Access the number edit menu',
	help_audio_transcription_7: 'Go to the "Additional settings" menu of the desired number.',
	help_audio_transcription_8: 'Enable the Audio Transcription option',
	help_audio_transcription_9: 'Find the "Audio transcription" section.',
	help_audio_transcription_10: 'Click on "Enabled" to activate the feature.',
	help_audio_transcription_11: 'Enter your OpenAI key',
	help_audio_transcription_12:
		'When activating the feature, you will be asked to enter the token (API key) from your OpenAI account.',
	help_audio_transcription_13: 'Enter the token and save the changes.',
	help_audio_transcription_14: '✅ Done!',
	help_audio_transcription_15:
		'Audio messages received by this number will now be transcribed automatically in real time.',
	help_audio_transcription_16: '🔎 Status Monitoring',
	help_audio_transcription_17:
		'The transcription status for each number can be viewed directly in the Powerzap control panel.',
	help_audio_transcription_18:
		'You can enable or disable the feature at any time for each individual number.',
	help_audio_transcription_19: 'ℹ️ Notes',
	help_audio_transcription_20:
		'This feature is not yet available for other integration platforms (MessageBird, Twilio, uTalk, and Meta).',
	help_audio_transcription_21:
		'Make sure your OpenAI key has sufficient credits and access to the audio transcription feature (such as the whisper-1 model).',
	help_audio_transcription_22: '🔈 Supported audio formats:',

	// PowerZap
	number_disconnected:
		'Your number is disconnected, restart your session by clicking on the button bellow',
	number_disconnected_alert: 'Number disconnected: Read the QR Code of',
	meta_disconnected_alert_title: 'Channel disconnected',
	meta_disconnected_alert_body:
		'This number is disconnected from official WhatsApp. Reconnect without losing settings or history.',
	meta_disconnected_alert_cta: 'Reconnect',
	disconnect: 'Disconnect',
	connected_number: 'Connected number:',
	starting_container:
		"Your session is starting, this procedure can take around 5 minutes. Take this time to hydrate yourself, we'll let you know when your QR Code is available.",
	session_start_alert: 'Your PowerZap session has started, please read your QRCode!',
	reading_qrcode_message: 'After reading the QR Code, wait for your session information to load.',
	qrcode_polling_failed: 'Could not refresh the QR Code',
	qrcode_polling_failed_message:
		'We had a problem generating a new QR Code. Try again or use the alternative connection method below.',
	zapi_alternative_method_cta: 'Trouble connecting? Use the alternative method',
	zapi_alternative_method_error:
		'Could not open the alternative connection method. Please try again shortly.',
	zapi_alternative_method_not_ready:
		'Your connection is still being prepared. Please wait a moment and try again.',
	zapi_alternative_method_connected:
		'Connected successfully! Please wait a moment for final confirmation.',
	zapi_alternative_method_cancelled:
		'Alternative method closed without completing the connection. You can try again whenever you want.',
	zapi_alternative_method_sdk_error:
		'An error occurred while connecting through the alternative method. You can try again.',
	zapi_alternative_method_expired: 'Your instance has expired. Please contact support to renew it.',
	start_session_failed: 'Failed to start new session',
	register_on_chat_switch: 'Send message to Bitrix24 Chat',
	register_on_chat_switch_alert:
		'<strong>Starting conversations from this functionality may cause problems with bots</strong>',
	register_on_chat_switch_disabled: 'You must have a conversation started to enable this feature.',
	register_on_chat_fail: 'Failed to send message to Bitrix24 chat',
	retry_send_message_without_register: 'Sending message to integrator outside chat...',
	error_empty_channel_id: 'Cannot find open channel for selected number',
	error_empty_dialog_id: 'Cannot find a chat for entity and number',
	confirm_set_number_on_pattern:
		'We have identified that a destination number is outside the new Brazil standard, which includes the ninth digit. Do you want to change it automatically and proceed?',

	// Br24 API (zapi)
	radio_zapi: 'Default App Integrator',
	zapi_description_1: 'Scan the QR Code to connect your WhatsApp number to the app.',
	zapi_description_2:
		'To connect you need to open the WhatsApp application on your device, in the upper left corner click on the three dots and access "Connected Devices".',
	meta_description: 'For connection via Official API, access the <link>Complete Guide</link>.',

	// Help arquivos suportados
	supported_files_title: 'Sending Files',
	help_maximum_file_size_1:
		'The PowerZap application is a platform that allows you to send and receive messages efficiently and reliably. However, it is important to highlight that the APP has a <b>file upload limit of up to 100MB per transfer</b>. This size limit policy is intended to ensure the stability and speed of the service, providing users with the best possible experience when sharing documents, photos, videos and other types of files.',
	help_maximum_file_size_2:
		'If you need to send larger files, we recommend breaking the content into smaller chunks or exploring other sharing options to ensure successful delivery of the material.',
	help_maximum_file_size_3: '<b>It is important to pay attention to the warnings:</b>',
	help_maximum_file_size_4:
		'Warning displayed when trying to send a file larger than 100MB via card.',
	help_maximum_file_size_5:
		'Warning displayed when trying to send a file larger than 100MB via Bitrix24 chat.',
	help_maximum_file_size_6:
		'Warning displayed when trying to send a file larger than 100MB through automation.',

	// Installation Errors and Messages
	handler_bizproc_activity: 'Failed to register Automation Flow activity',
	handler_bizproc_robot: 'Failed to register automation',
	register_event: 'Failed to register event',
	register_placement: 'Failed to register placement',
	handler_imconnector_message: `The Contact Center Connector is the connection between the WhatsApp Integration API application and Bitrix24 conversations.
    It's recommended to ask the administrator to reinstall the application and if the problem persists, please contact the support.`,
	handler_bizproc_activity_message:
		'This error may prevent the creation of the option to use the application in your automation workflow. This may occur if your Bitrix24 plan does not include the use of automations.',
	handler_bizproc_robot_message:
		'This error may prevent the use of automations for sending WhatsApp messages. This error may occur if your Bitrix24 plan does not support the use of automations.',
	register_event_message:
		'This error prevents the application from receiving an event that occurs in Bitrix24.',
	register_placement_message:
		'This error prevents the application from registering in a tab of your Bitrix24, making it impossible to use it in the given tab.',
	installation_errors_found: 'Your installation process failed, learn more:',
	error_found: 'Error found',

	amount_of_numbers_pro: 'Numbers used: PowerZap {active_pro}/{total_pro}',
	amount_of_numbers_basic: 'Numbers used: BASIC {active_basic}/{total_basic}',
	campaign_title: 'List of numbers associated with marketing campaigns',
	pro_numbers_title: 'PowerZap number list',
	basic_numbers_title: 'Basic numbers list',
	add_pro_numbers_title: 'Add new PowerZap number',
	create_pro_trial: 'Try a Powerzap Number',
	add_basic_numbers_title: 'Add new Basic number',
	api_connected: 'Status',
	subscription: 'Subscription',
	plan_limit: 'You have reached your plan limit',

	// Marketing Campaign
	status_tooltip:
		"The WhatsApp message status (delivered and read) depends on the contact's privacy settings.",
	write_your_campaign_message: 'Write your campaign message',
	write_your_message_here: 'Write your message here',
	upload_file_max_size: 'The maximum file size allowed by Meta is 100MB',
	select_variable: 'Select a variable',
	new_campaign: 'New Campaign',
	search: 'Search',
	send_manually: 'Send manually',
	campaign_name: 'Campaign Name',
	scheduled_for: 'Scheduled for',
	reschedule: 'Reschedule',
	campaign_reschedule: 'Reschedule campaign delivery',
	reschedule_message_success: 'Campaign rescheduled successfully!',
	reschedule_message_error: 'Error rescheduling campaign.',
	remaining_time: 'Remaining time',
	sent: 'Sent',
	delivered: 'Delivered',
	read: 'Read',
	failed: 'Failed',
	error: 'Error',
	status_pending: 'Pending',
	start_sending_now: 'Start sending now',
	view_campaign_items: 'View details',
	destination_number: 'Destination Number',
	message_status: 'Message Status',
	message_success: 'Message sent successfully.',
	campaign_not_send: 'The campaign was not sent because it was outside business hours.',
	campaign_not_send_openline:
		'The campaign was not sent because it was not possible to verify the working hours in Bitrix24.',
	description_status: 'Description',
	delete_campaign_confirmation:
		'Are you sure you want to delete this campaign? This action cannot be undone and will immediately cancel the campaign execution.',
	of: 'of',
	finished: 'Finished',
	awaiting_start: 'Awaiting start',
	queued: 'Queued',
	estimating: 'Estimating',
	less_than_a_minute: 'Less than a minute',
	hour: 'hour',
	minute: 'minute',
	and: 'and',
	set_campaign_name: 'Set the campaign name',
	campaign_name_placeholder: 'Campaign name',
	deal: 'Deal',
	contact: 'Contact',
	lead: 'Lead',
	company: 'Company',
	field_required: 'This field is required',
	configure_segment: 'Configure the campaign segment',
	define_campaign_segment: 'Define the campaign segment name',
	segment_name: 'Segment name',
	conditionals: 'Conditionals',
	bigger_than: 'Bigger than',
	smaller_than: 'Smaller than',
	equal_to: 'Equal to',
	different_from: 'Different from',
	bigger_or_equal_to: 'Bigger or equal to',
	smaller_or_equal_to: 'Smaller or equal to',
	contains: 'Contains',
	add_field: 'Add field',
	segment_user_search_placeholder: 'User (full list on open; filter by name)',
	required_campaign_name: 'The campaign name is required',
	required_source_number: 'The source number is required',
	required_audience: 'The audience is required',
	required_segment: 'The segment is required',
	required_message: 'The message is required',
	required_template: 'The template is required',
	required_parameters: 'The parameters are required',
	required_send_when: 'When to send is required',
	required_send_date: 'The send date is required',
	name: 'Name',
	audience: 'Audience',
	message: 'Message',
	finish: 'Finish',
	saving: 'Saving',
	save: 'Save',
	all_contacts: 'All contacts',
	all_companies: 'All companies',
	all_leads: 'All leads',
	all_deals: 'All deals',
	all_base: 'All base',
	deals: 'Deals',
	contacts: 'Contacts',
	companies: 'Companies',
	define_campaign_audience: 'Define the campaign audience',
	source_number: 'Source number',
	select_source_number: 'Select the source number',
	select_audience_type: 'Select the audience type',
	static_list: 'Static list',
	dynamic_list: 'Dynamic list',
	custom_recipients:
		'Custom recipients list, separated by comma or line break. Ex: 5511999999999, 5511999999999 or \n5511999999999\n5511999999999',
	select_segments: 'Select the segments',
	segment_filters: 'Segment filters',
	select_campaign_template: 'Select the campaign template',
	choose_variables: 'Choose between the available variables or type the value manually',
	campaign_ready_1: 'The campaign',
	campaign_ready_2: 'is ready to be sent!',
	campaign_worktime_title: 'Send campaigns only during business hours',
	campaign_worktime_tooltip:
		'Messages sent outside business hours will be automatically rescheduled.',
	when_to_send: 'When do you want to send?',
	now: 'Now',
	later_manually: 'Later, manually',
	schedule: 'Schedule',
	saving_campaign: 'Saving campaign...',
	campaign_ready_title: 'Your campaign is ready!',

	// PricingCard Component
	billing_cycle: 'month',
	basic_tag_label: '',
	basic_description: 'Official API connector only.',
	basic_feature_1: 'Official API Connector',
	basic_feature_2: 'Number approved by Facebook',
	basic_feature_3: 'Unlimited messages',
	basic_feature_4: 'Conversation History in CRM',
	basic_feature_5: 'Multiple agents per WhatsApp number (optional)',
	basic_button_label: 'Get Basic',
	pro_tag_label: 'Most popular',
	pro_description: 'Complete PowerZap Connector/Integrator Package.',
	pro_feature_1: 'Connector + PowerZap Integrator',
	pro_feature_2: 'No need for templates',
	pro_feature_3: 'Sending and receiving audios',
	pro_feature_4: 'Conversation History in CRM',
	pro_feature_5: 'Simplicity for setting up new numbers',
	pro_button_label: 'Get Pro',

	// CurrentPlan Component
	current_plan_title: 'Current plan',
	current_plan_name: 'Basic',
	current_plan_billing_cycle: 'Price',
	current_plan_next_invoice: 'Next invoice',
	current_plan_features: 'Basic Plan features',
	current_plan_feature1: 'uTalk integrator*',
	current_plan_feature2: ' MessageBird integrator',
	current_plan_feature3: '20/month messages exchanged',
	current_plan_utalk_deprecated: '* Integration will be discontinued soon',

	// CustomizingPlan Component
	customize_plan_pro_title: 'Plan Pro | Personalize your plan',
	customize_plan_pro_description: 'It already includes a PowerZap and an official API number.',
	customize_plan_basic_title: 'Plan Basic | Personalize your plan',
	customize_plan_basic_description: 'It already includes one Official API number.',
	customizing_plan_billing_period: 'Payment period',
	customizing_plan_pay_month: 'Monthly',
	customizing_plan_pay_year: 'Yearly',
	customizing_plan_months_free: '~ 2 months free',
	customizing_plan_additional_numbers: 'Additional numbers',
	customizing_plan_total: 'Total',
	customizing_plan_cancel_button: 'Cancel',
	customizing_plan_confirm_button: 'Confirm',
	api_official: 'Official API',
	success_title: 'Your plan has been updated to {planName} successfully',
	success_subtitle: 'The next invoice will be sent in the next billing cycle.',
	error_400: 'Unable to upgrade a subscription with YEARLY plan',
	error_500: 'Unable to update your subscription',
	error_subtitle: 'Please contact support.',
	go_to_dashboard_button: 'Go to Dashboard',

	PAID: 'SUBSCRIBED',
	PENDING: 'EXPIRED',
	TRIAL: 'TRIAL',
	CANCELED: 'CANCELED',
	CANCELLATION_PROCESS: 'CANCELLING',

	// numberitem Component
	validity_trial: 'Your integrator trial will expire in {validity}.',

	// marketing view

	change_value:
		'⚠️ Important announcement - From the 1st of August, there will be a change in the price of our services!',
	promotional_value: 'Promotional value until July 31. Enjoy!',

	marketing_cta_title: 'Marketing Campaigns via WhatsApp!',
	topic1: 'Segment your campaigns to reach exactly who you want.',
	topic2: 'Send your messages at the most convenient time for your customers.',
	topic3: 'Send campaigns with media files for a stronger and more effective visual impact.',
	topic4: 'Track the results and efficiency of your campaigns to improve them continuously.',
	button_form: 'Register interest',
	marketing_form_title: 'Want to be one of the first to learn more about this news?',
	confirmation_title: 'Interest registered!',
	confirmation_subtitle: 'We will contact you soon with more information.',

	Form_input_1: 'What is the main goal of using WhatsApp campaigns?',
	Form_input_1_opcion: 'Select an option',
	Form_input_1_opcion_1: 'Increase customer engagement',
	Form_input_1_opcion_2: 'Promote new products or services',
	Form_input_1_opcion_3: 'Inform about promotions and discounts',
	Form_input_1_opcion_4: 'Improve communication and relationship with customers',
	Form_input_1_opcion_5: 'Get customer feedback',
	Form_input_1_opcion_6: 'Others',
	Form_input_2: 'Please specify:',
	Form_input_3: 'Do you already use WhatsApp campaigns?',

	// permission view
	permission_title: 'Permission Groups',
	new_group: 'New Group',
	group_name: "Group's Name",
	numbers: 'Numbers',
	users: 'Users',
	group_actions: 'Actions',
	create_group_success: 'The permissions group has been created!',
	create_group_error: 'Unable to create permission group',
	create_new_permission_group: 'Create new permission group',
	edit_new_permission_group: 'Edit new permission group',
	i_permission_group_name: 'Permission group name',
	whatsapp_numbers: 'Whatsapp number',
	placeholder_group_name: 'Enter group name',
	i_whatsapp: 'Connected WhatsApp number',
	placeholder_whats_app: 'Click here and select the number',
	i_users: 'Your portal users',
	placeholder_users: 'Click here and select the user',
	permission_deleted_notification: 'Are you sure you want to delete this permission group?',
	btn_delete_ok: 'Yes, I want to delete',
	btn_delete_cancel: 'Cancel',
	delete_group_success: 'Permission group successfully deleted!',
	delete_group_error: 'Unable to delete permission group',
	edited_group_success: 'Permission group edited successfully!',
	edited_group_error: 'Unable to edit permission group',
	user_not_found: 'No users found',
	permissions: 'Permissions',
	permissions_introduction:
		'The "Permissions" tab is the central place to manage user access to each number connected to your account. Here, you will find the following features:',
	permissions_introduction_1:
		'<b>List of Groups:</b> View the list of permission groups already created;',
	permissions_introduction_2:
		'<b>Create New Group:</b> Easily create a new permissions group to customize access;',
	permissions_introduction_3:
		'<b>Edit Existing Groups:</b> Make adjustments to permission groups as needed;',
	permissions_introduction_4: '<b>Delete Groups:</b> Remove groups that are no longer needed;',
	permissions_introduction_5:
		'Only users with administrator privileges have access to this functionality.',
	permissions_introduction_6: '<b>Benefits of Permission Groups:</b>',
	permissions_introduction_7:
		'Once a permission group is created, only users added to it will have access to the following areas and functionalities:',
	permissions_introduction_8: 'Control Panel;',
	permissions_introduction_9: 'Number Edit;',
	permissions_introduction_10: 'Sending Messages via Card CRM;',
	permissions_introduction_11:
		'This feature allows for more precise control over who can interact with connected numbers and perform specific actions.',
	permissions_tutorial:
		'On the "Permissions" screen, you will have access to the permission groups related to each number registered in PowerZap.',
	permissions_tutorial_1:
		'<b>Default Group:</b> The "default" group is created automatically and includes the list of connected numbers and all users of your Bitrix24 portal:',
	permissions_tutorial_2: '<b>Creating a New Group:</b>',
	permissions_tutorial_3: 'On the main screen, click "New Group" to create a new permission group:',
	permissions_tutorial_4:
		'When you click on the "New Group" button, you will be redirected to the screen to create a new group:',
	permissions_tutorial_5: 'Fill in the form with the following fields:',
	permissions_tutorial_6: '<b>Group Name:</b> Enter the name of the group you want to create:',
	permissions_tutorial_7:
		'<b>WhatsApp number:</b> Select the connected number you want to associate with the new group:',
	permissions_tutorial_8: '<b>Users:</b> Select the users who will be part of this group:',
	permissions_tutorial_9:
		'You can choose the "All" option to add all your portal users to this new group or select users individually:',
	permissions_tutorial_10:
		'To facilitate user selection, use the search function. Enter the user name and it will appear in the list for selection:',
	permissions_tutorial_11: 'After filling in the fields, click "Save" to create the new group:',
	permissions_tutorial_12:
		'If desired, click "Back" to return to the main screen of the "Permissions" tab:',
	permissions_tutorial_13: '<b>Editing a Permission Group:</b>',
	permissions_tutorial_14:
		'You can edit the information for an existing permission group. To do this, click the "Edit" button in the actions column of the group you want to edit:',
	permissions_tutorial_15:
		'You will be redirected to the edit page, where you will find a form filled out with the data of the group you want to edit:',
	permissions_tutorial_16: 'Edit group name, WhatsApp number and users as needed:',
	permissions_tutorial_17: 'Click "Save" to confirm changes:',
	permissions_tutorial_18:
		'If you prefer, click "Back" to return to the main screen of the "Permissions" tab:',
	permissions_tutorial_19: '<b>Deleting a Permission Group:</b>',
	permissions_tutorial_20:
		'You can also delete an existing permission group. To do this, click the "Delete" button in the actions column of the group you want to delete:',
	permissions_tutorial_21:
		'After clicking "Delete", a confirmation will be displayed on the screen to ensure that you want to delete the group:',
	permissions_tutorial_22:
		'If you want to cancel the deletion, click "Cancel", and the group will not be deleted:',
	permissions_tutorial_23:
		'If you are sure you want to delete the group, click "Yes, I want to delete", and the group will be removed successfully:',
	permissions_tutorial_24:
		'We hope the guidance makes managing permission groups easier. If you have any additional questions, please contact our support.',
	permissions_alert: 'Learn how to create permission groups in PowerZap! {link}',
	notifiable_users_alert:
		'Now you can set users who should receive important notifications about the app! {link}',
	click_here: 'Click here.',
	notify_click_here: 'Click here to configure',
	notifiable_save_success: 'Users to be notified saved successfully',
	notifiable_save_error: 'There was an error saving the settings',
	notifiable_tooltip:
		'Define the users who will receive important notifications about the application.',
	notifications: 'Notifications',
	notified_users: 'Notified Users',

	notifiable_widget_alert: 'NEW 🎉🎉 Create WhatsApp widgets in a simplified way. {link}',
	notify_click_here_widget: 'Click here to find out more.',
	sendings_by_type: 'Sendings by type',
	total_messages: 'Total:',
	received: 'Received',
	crm: 'CRM',
	automacao: 'Automation',
	campanha: 'Campaigns',
	chat: 'Chat',
	percentage_evolution_tooltip: 'Evolution compared to the daily average of the previous month',
	percentage_total_tooltip: 'Proportion of total messages exchanged',
	percentage_sent_tooltip: 'Proportion of total sendings',
	select_month: 'Select Month',
	insights: 'INSIGHTS',
	insights_unavailable: 'This feature is unavailable for the current domain',
	chart_messages_total: 'Total messages',
	chart_messages_total_title: 'Total Messages',
	chart_sent_and_received_title: 'Sent and Received Messages',
	chart_sending_types_title: 'Automations, Campaigns and Audios Sent',
	chart_messages_sent: 'Sent',
	chart_messages_received: 'Received',
	chart_automation: 'Automations',
	chart_campaign: 'Campaign',
	chart_audio: 'Audio',
	insight_form_error_title: 'There was an error submitting the form.',
	insight_form_error_subtitle: 'Please reload the page and try again.',
	insight_form_error_message: 'If the problem persists, contact our support.',
	insight_form_already_submitted_title:
		'Your interest in the Insights feature has already been recorded.',
	insight_form_already_submitted_subtitle:
		'As soon as it becomes available, you will be one of the first to try it out.',
	insight_form_success_title: 'Done!',
	insight_form_success_subtitle: 'Your interest has been forwarded to our team.',
	insight_form_success_message: 'We will contact you shortly.',
	insight_form_title: 'Would you like to view your Dashboard?',
	insight_form_subtitle: 'Fill out the form to request information.',
	insight_form_message: 'We promise not to use your contact information to send any kind of spam.',
	insight_form_name: 'Name*',
	insight_form_email: 'Email*',
	insight_form_whatsapp: 'WhatsApp',
	insight_form_send: 'Send',
	insight_form_required_field: 'This field is required',
	widget_feature: 'WhatsApp Button Generator',
	widget_feature_description:
		'Create custom buttons to add to your website and automatically capture leads. {link}',
	widget_create_button: 'Create Widget for Websites',
	widget_table_title: 'Widget Interactions',
	widget_table_title_tooltip:
		'Data collected from interactions with Widgets of numbers connected to your PowerZap.',
	widget_url: 'Widget Website',
	widget_url_tooltip: 'Url of the site where the widget was added.',
	widget_number: 'Number',
	widget_redirects: 'Redirects',
	widget_redirects_tooltip:
		'Number of times a customer clicked on the widget and was redirected to your WhatsApp number.',
	widget_table_download: 'Download Data',
	chart_widget_title: 'Widget Interactions By Month',
	chart_clicks: 'Clicks',
	chart_redirects: 'Redirects',
	create_widget_button: 'Create Widget',
	create_widget_button_tooltip:
		'Create a button to add to your website and allow visitors to contact you via WhatsApp.',
	objective_with_the_application: 'Main objective with the application',
	select_objective: 'Select',
	option_increase: 'Increase the sales',
	option_improve: 'Increase customer service efficiency',
	option_automate: 'Automate communications',
	option_whatsapp: 'Carry out marketing campaigns via WhatsApp',
	option_extract: 'Extract insights from interactions with customers and leads',
	option_centralize: 'Centralize communications on a single platform',
	option_other: 'Other',
	input_name: 'Type your name',
	input_email: 'Type your email',
	input_website: 'Enter your website address',
	input_phone_label: 'Telephone',
	input_phone: 'Enter your phone number',
	virtual_number_title: 'Add virtualized number',
	virtual_number_tooltip:
		'With the virtualized number, there is no need to use smartphones or emulators for each number. The connection is completely virtual.',
	virtual_number_form: 'Interested in adding a virtualized number (without a smartphone)?',
	virtual_number_form_subtitle:
		'Fill out the form below and our team will provide you with more details about how it works.',
	virtual_number_input_1: 'Name',
	virtual_number_input_1_placeholder: 'Type your name',
	virtual_number_input_2: 'Email',
	virtual_number_input_2_placeholder: 'Type your e-mail',
	virtual_number_input_3: 'WhatsApp',
	virtual_number_input_3_placeholder: 'Enter your WhatsApp number',
	virtual_number_input_4: 'Quantity of virtualized numbers',
	virtual_number_input_4_placeholder: 'Select the number of virtualized numbers',
	virtual_number_send: 'Send',
	virtual_number_option_1: '1 number',
	virtual_number_option_2: '2 numbers',
	virtual_number_option_3: '3 numbers',
	virtual_number_option_4: '4 numbers',
	virtual_number_request: 'Enter virtual number ',
	virtual_number_error_1: 'There was an error submitting the form',
	virtual_number_error_2:
		'Please, reload the page and try again. If the problem persists, contact our support.',
	virtual_number_success_1: 'Done!',
	virtual_number_success_2:
		'Your interest has been passed on to our team. Soon, we will contact you.',
	btn_loading_trial: 'Sending data, please wait...',
	virtual_number_name_error_1: 'Please, enter your name',
	virtual_number_name_error_2: 'The name must contain only letters',
	virtual_number_email_error_1: 'Please, enter your email',
	virtual_number_email_error_2: 'Please enter a valid email',
	virtual_number_whats_error_1: 'Please, enter your WhatsApp',
	virtual_number_whats_error_2: 'WhatsApp should only contain numbers',
	virtual_number_quantity_error: 'Please, select the number of virtualized numbers',
	virtual_number_virtualized_error: 'Please, enter the WhatsApp number to be virtualized',
	form_trial_website_error: 'Please, enter the company website',
	form_trial_country_error: 'Please, select your country',
	form_trial_phone_error_1: 'Please, enter your phone number',
	form_trial_phone_error_2: 'The phone must contain only numbers',
	form_trial_objective_error: 'Please, select the main objective with the application',
	help_360_dialog_1: '360dialog (Official API)',
	help_360_dialog_2: 'How to connect your 360dialog account to Bitrix24',
	help_360_dialog_3:
		'To configure our connector with 360dialog, you can start with PowerZap itself. Check out the following video to learn how to configure the integration and send your first messages via Bitrix24:',
	help_360_dialog_4: 'Your browser does not support the video tag.',
	help_360_dialog_5:
		'Do you already have a 360dialog account and would like to request a partner change?',
	help_360_dialog_6: 'Follow this partner switching guide',
	help_360_dialog_7: ' and, if necessary, inform the Br24 partner ID: {partner}.',
	help_360_dialog_8: 'Detailed tutorial',
	help_360_dialog_9: 'How to connect a WhatsApp 360dialog number in Bitrix24:',
	help_360_dialog_10:
		'To connect a new number, simply click on "Add new number" in the Basic numbers section.',
	help_360_dialog_11:
		'As soon as the pop-up opens, select the API option “360dialog” and click on “Add new number”',
	help_360_dialog_12:
		'After that, you will notice that a new window will open over PowerZap. In it, you will create your 360dialog account by filling in the form fields or, if you already have a 360dialog account, simply log in to the account by clicking “Log In” at the top of the window.',
	help_360_dialog_13:
		'If you already have a 360dialog account contracted directly with them, you can ask 360dialog support to change your plan, indicating the contracting through a 360dialog partner (PowerZap - Br24), thus receiving a discount on the price of the plan.',
	help_360_dialog_14: "For more information about 360dialog's pricing",
	help_360_dialog_15: ' access this link.',
	help_360_dialog_16:
		'Note: If you are using Chrome as your browser, you can translate the steps by right-clicking and selecting the option to translate to Portuguese. From now on, we will show the translated pages in Portuguese.',
	help_360_dialog_17:
		'In the next step, you will need to provide the current status of the WhatsApp number you want to add.',
	help_360_dialog_18: 'If your number is connected to the WhatsApp Business API',
	help_360_dialog_19:
		'After selecting the option and clicking on “Confirm number details”, proceed by entering the phone number you want to add and validate the necessary information in order to continue.',
	help_360_dialog_20:
		'In the next step you will need to complete the Meta embedded registration, just follow the step-by-step instructions.',
	help_360_dialog_21:
		'After completing the embedded registration, you will see a window with the Facebook logo, where you must continue',
	help_360_dialog_22:
		'After following the previous step, fill in the requested information and follow the next 4 steps.',
	help_360_dialog_23:
		'Note: If the number to be linked is linked to another integrator (e.g. Twilio), it will first be necessary to unlink it from this integrator before proceeding to the next step.',
	help_360_dialog_24:
		'Now, just proceed with the authorization of the partner application, where the partner is Br24.',
	help_360_dialog_25:
		'After authorizing the partner application, just wait a few seconds. At this point, a message will be sent to the application, which will in turn add the new number to your portal.',
	help_360_dialog_26:
		'Once the success message appears, simply close the window and reload the PowerZap page.',
	help_360_dialog_27:
		'⚠️ To send your messages via the Official Meta API through PowerZap, you must first validate these messages in 360dialog. These validated/to-be-validated messages are called “templates”. To do this, simply log in to 360dialog and follow the steps below ',
	help_360_dialog_28: 'step-by-step model validation.',
	help_360_dialog_29:
		'If your number is NOT connected to the WhatsApp Business API but is connected to a personal account',
	help_360_dialog_30:
		'If your number is connected to a personal WhatsApp account, you will need to disconnect your number from your personal account to migrate to a WhatsApp Business API account. To do this, simply click on ',
	help_360_dialog_31: '“How to disconnect a number from a personal WhatsApp account” ',
	help_360_dialog_32: 'and follow the step-by-step instructions.',
	help_360_dialog_33:
		'After that, you will need to return to this step and select the option “No, this number is not connected to a personal WhatsApp account”.',
	help_360_dialog_34:
		'If your number is NOT connected to the WhatsApp Business API and a personal account',
	help_360_dialog_35: 'If your number does not meet either of the two options, you will need to ',
	help_360_dialog_36: 'connect your number to the WhatsApp Business API in your Meta account.',
	help_360_dialog_37: 'After that, you will need to return to this window and follow as follows ',
	help_360_dialog_38: 'this step-by-step.',
	help_360_dialog_39: 'Templates',
	help_360_dialog_40:
		'A message template is required for the Company to start a new conversation with your contact. This is necessary if there has been no interaction between the two parties previously or if the last message sent by the user is more than 24 hours old. For more details, ',
	help_360_dialog_41: 'click here.',
	help_360_dialog_42:
		'After validation, the templates must be available for sending via PowerZap (via card and automation).',
	help_360_dialog_43: 'Manual submission:',
	help_360_dialog_44:
		'To configure automation, you must enter the template name followed by “#template:”. You can also customize the message with information registered in the cards. To do this, simply enter the fields to be used, as shown in the following example:',
	help_360_dialog_45: 'Do you have any questions about 360dialog?',
	help_360_dialog_46: 'Contact the 360 ​​Dialog support team via the website ',
	help_360_dialog_47: 'https://www.360dialog.com/contact ',
	help_360_dialog_48: 'or by email at support@360dialog.com',
	help_360_dialog_49: '360dialog Help',
	help_360_dialog_50: 'Have any questions about 360 Dialog?',
	help_360_dialog_51: 'Contact 360dialog support via the website ',
	help_360_dialog_52: 'Connect the 360',
	notification_checkbox: 'Receive notification of invalid number.',
	info_notification:
		'By selecting this option, some users will receive notifications if a message is sent to an invalid number through a pro number.',
	info_notification_2:
		'Card sending: The card owner, the sender, and the people registered in this list will receive the notification.',
	info_notification_3:
		'Automation sending: It will be sent to the card owner and to the people in this list.',
	info_notification_4: 'Campaign sending: Only those in this list will receive the notification.',
	help_360_dialog_53: 'Creating/approving templates:',
	help_360_dialog_54: 'Accessing the 360dialog Panel:',
	help_360_dialog_55:
		'In the 360dialog panel, locate the "Templates" section. Here, you can create new message templates, which are required to initiate conversations in categories such as marketing, utility, or authentication.',
	help_360_dialog_56: 'Creating a new template:',
	help_360_dialog_57: 'Click on "Create new template".',
	help_360_dialog_58:
		'When creating a template, you must provide details such as the template name, message language, and conversation category (marketing, utility, or authentication).',
	help_360_dialog_59:
		'Choose an appropriate category based on the purpose of the message to be sent (for example, "marketing" for promotions or "utility" for order updates).',
	help_360_dialog_60: 'Defining the Message Content:',
	help_360_dialog_61:
		'Next, you need to fill in the message body with the template text. The message can contain dynamic variables, represented by placeholders such as {{1}}, {{2}}, which can later be filled with specific customer information.',
	help_360_dialog_62:
		'Text formatting can include parameters for personalization and media options, such as adding buttons, images, or links that are useful for customer communication.',
	help_360_dialog_63:
		'After defining the message content, simply proceed by clicking on "Preview and submit".',
	help_360_dialog_64: 'Template Preview:',
	help_360_dialog_65:
		'Before submitting the template for approval, use the Template Preview function to review how the message will appear on the recipient’s WhatsApp.',
	help_360_dialog_66:
		'This feature allows you to visualize the layout, text formatting, and correct insertion of variables. Additionally, you can check the arrangement of buttons, images, and other interactive elements included in the template.',
	help_360_dialog_67: 'Template Validation:',
	help_360_dialog_68:
		'Once submitted, the template status will change to "Pending," indicating that it is awaiting approval.',
	help_360_dialog_69:
		'When approved, the template status will change to "Approved," and you can start using it in your campaigns or communications.',
	help_360_dialog_70:
		'If the template is rejected, you will receive a justification, such as the need for content adjustments.',
	openai_token_required: 'OpenAI API key is required to enable audio transcription',
	openai_token_invalid:
		"Invalid OpenAI API key format. It should start with 'sk-' and be at least 48 characters long",
	audio_transcription_tooltip:
		'Provide your OpenAI API key so that PowerZap can automatically transcribe received audio messages to text.',
	rapid_reply_title: 'Quick reply buttons',
	new_button_placeholder: 'New button...',
	select_options_to_continue: 'Select options to continue.',
	confirm: 'Confirm',
	call: 'Call',
	no_thanks: 'No, thank you',
	i_want: 'I want',
	no: 'No',
	rapid_reply_tooltip: 'Select or create buttons to stimulate quick and objective responses.',
	files_with_buttons: 'Sending files with buttons',
	files_with_buttons_tooltip:
		'Sending files with buttons supports images and vídeos, other types of files are not supported and cannot work properly.',
	invalid_number: 'One of the numbers provided is invalid.',

	help_meta_connect: 'How to connect',
	help_meta_title: 'Avoid your number being blocked',
	help_meta_description:
		'To prevent your number from being blocked by Meta during integration, follow this checklist before continuing:',
	help_meta_item_1: "Use only Meta's Official API",
	help_meta_item_1_description:
		'Your number must not be connected to any unofficial API platforms, including Powerzap Pro number.',
	help_meta_item_2: 'Verify your business on Meta',
	help_meta_item_2_description: '<link>Verify now</link>',
	help_meta_item_3: 'Add a valid payment method on Meta',
	help_meta_item_3_description: '<link>Add payment method</link>',
	help_meta_item_4: 'Have at least one approved message template',
	help_meta_item_4_description: '<link>Create message template</link>',
	help_meta_info:
		'For more details, access the <link>Complete Step-by-Step Guide</link> for Meta Official API integration on Powerzap.',
	help_meta_btn: 'Next',
	help_meta_confirm_checkbox:
		'I confirm that I have completed all the above items and understand that proceeding without meeting the checklist may result in the number being blocked by Meta.',

	// SURVEY
	survey_send_response_button: 'Submit',
	survey_answered_title: 'This survey has already been answered!',
	survey_answered_description:
		'Stay tuned: as soon as we have news, you’ll be one of the first to know. 🚀',
	survey_modal_close_button: 'Close',
	survey_modal_discard_button: 'Discard',
	survey_modal_discard_tooltip: 'If you discard, this survey will not appear again.',
	survey_modal_redisplay_button: 'Remind me later',
	survey_modal_alert_required_fields: '* Required fields',
	survey_input_required_error: 'Required field',
	survey_helper_text_input_1: 'Select one option',
	survey_helper_text_input_2: 'Select at least one option',
	survey_helper_max_selections_1: 'Select only one option',
	survey_helper_max_selections_2: 'Select up to {maxSelections} options',
	survey_feedback_send_event_ignored:
		'We will redisplay the survey in {redisplayInDays} {redisplayInDaysText}.',
	survey_feedback_send_event_discarded: 'You have permanently discarded the survey.',
	survey_feedback_send_event_error: 'Error registering event.',
	survey_feedback_send_response_error: 'Error sending survey response.',
	survey_feedback_send_response_success: 'Thank you for answering our survey!',

	cta_kory_dashboard_title:
		'<highlight>Connecting</highlight> your WhatsApp \n to Bitrix24 <b>has never been so easy</b>.',
	cta_kory_dashboard_cta: 'Discover our new App.',

	cta_powerbot_campaign_title:
		'Campaigns attract conversations. \n Automation helps turn \n conversations into opportunities.',
	cta_powerbot_campaign_subtitle:
		'Connect marketing campaigns with \n automatic qualification in <b>Powerbot.</b>',

	cta_kory_insights_title:
		'We evolved data control \n to deliver even \n <b>more insights in Kory Chat.</b>',

	cta_powerbot_permissions_title: 'Your team grows. <b>Your support needs to keep up.</b>',
	cta_powerbot_permissions_title_large: 'Your team grows.\n<b>Your support needs to keep up.</b>',
	cta_powerbot_permissions_subtitle:
		'Gain more scale with standardization \n using bots and AI in <b>Powerbot.</b>',
	cta_powerbot_permissions_subtitle_large:
		'<b>Gain more scale</b> with standardization <b>using bots and AI</b> in Powerbot.',

	migrate_kory_alert_title: 'Your PowerZap automations keep working in Kory One.',
	migrate_kory_alert_description:
		'Just keep the same number connected in Kory One that you used in your PowerZap automations — the migration happens automatically and nothing is lost.',
	migrate_kory_card_migrate_title: 'Migrate to Kory One',
	migrate_kory_card_migrate_description:
		'Migrate your PowerZap automations to Kory One in seconds.',
	migrate_kory_card_migrate_tooltip: 'Copies PowerZap automations and recreates them in Kory One.',
	migrate_kory_card_migrate_button: 'Migrate now',
	migrate_kory_card_revert_title: 'Back to PowerZap',
	migrate_kory_card_revert_description: 'Reverts the operation back to PowerZap if needed.',
	migrate_kory_card_revert_tooltip: 'Undoes the migration and restores automations to PowerZap.',
	migrate_kory_card_revert_button: 'Revert',
	migrate_kory_confirm_title: 'Before migrating, read carefully',
	migrate_kory_confirm_description:
		'To keep your automations working normally after the migration, please follow the steps below:',
	migrate_kory_confirm_warning_title: 'Keep PowerZap installed after the migration.',
	migrate_kory_confirm_warning_text:
		'Even without an active subscription, your PowerZap automations will continue working normally in Kory One.',
	migrate_kory_confirm_success_text:
		'No automation will be lost. Everything keeps working normally, now through Kory One.',
	migrate_kory_confirm_cancel: 'Cancel',
	migrate_kory_confirm_ok: 'Got it, migrate now',
	migrate_kory_error_title: 'Migration error',
	migrate_kory_success_title: 'Migration complete!',
	migrate_kory_success_description:
		'Your automations have been migrated to Kory One. To confirm, just test your automations as usual.',
	migrate_kory_success_button: 'Got it',
	migrate_kory_revert_success_title: 'Operation reverted successfully!',
	migrate_kory_revert_success_content: 'Your automations have been restored to PowerZap.',

	calls_export_tab_title: 'Export Calls',
	calls_export_title: 'Export calls as CSV',
	calls_export_description:
		'Download a CSV with the call notifications (WhatsApp) recorded for every client.',
	calls_export_button: 'Download CSV',
};
